var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leader-board-container"},[_c('ins',{class:[{ 'half-top-margin': _vm.halfTopMargin }, { 'no-top-margin' : _vm.noTopMargin}, 'adsbygoogle medium-rectangle'],attrs:{"data-ad-client":"ca-pub-2580109990739065","data-ad-slot":"4200499317"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd388a3a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeaderBoardMedium.vue
// module id = null
// module chunks = 